export type ClientQuestionnaireFormStatus = 'not-submitted' | 'submitted' | 'ended';

export interface ClientLoginState {
  emailError: boolean;
  clientEmail?: string;
  showTypeform: boolean;
  clientQuestionnaireFormStatus: ClientQuestionnaireFormStatus;
}

export const initialClientLoginState = () => {
  return {
    emailError: false,
    showTypeform: false,
    clientQuestionnaireFormStatus: 'not-submitted',
  } as ClientLoginState;
};

export interface ClientLoginAction {
  type: 'CLIENT_LOGIN_CREDENTIALS_MAIL_SUCCESS' | 'CLIENT_LOGIN_CREDENTIALS_MAIL_FAILURE' | 'SHOW_TYPEFORM_VISIBILITY' | 'SHOW_CLIENT_INTAKE_TYPEFORM';
  payload?: any;
}

const clientLoginReducer = (state: ClientLoginState = initialClientLoginState(), action: ClientLoginAction): ClientLoginState => {
  switch (action.type) {
    case 'CLIENT_LOGIN_CREDENTIALS_MAIL_SUCCESS': {
      return {
        ...state,
        emailError: false,
        clientEmail: action.payload,
      };
    }
    case 'CLIENT_LOGIN_CREDENTIALS_MAIL_FAILURE': {
      return { ...state, emailError: true };
    }
    case 'SHOW_TYPEFORM_VISIBILITY': {
      return {
        ...state,
        showTypeform: true,
      };
    }
    case 'SHOW_CLIENT_INTAKE_TYPEFORM': {
      return { ...state, clientQuestionnaireFormStatus: action.payload };
    }
    default:
      return state;
  }
};

export default clientLoginReducer;
